import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="not-found">
      <h1>404</h1>
      <p>Pagina nao encontrada.</p>
      <Link to="/" className="btn btn-secondary btn-sm">
        Voltar ao inicio
      </Link>
    </div>
  );
}
